export const APP_CONFIG = {
    DEFAULT_DATE_FORMAT: 'MM/DD/YYYY',
    DEFAULT_TIME_FORMAT: 'hh:mm A',
    DEFAULT_DATE_TIME_FORMAT: 'MM/DD/YYYY hh:mm A',
    S3_SCREENSHOT_BUCKET_PATH: 'https://test-accelerator-execution-screenshot.s3.us-east-1.amazonaws.com',
    FILE_URL: 'https://d3n939lywmim5h.cloudfront.net'
}